function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.4765 0.241168L16.4508 3.24117C16.536 3.32139 16.6032 3.41918 16.6476 3.52788C16.6921 3.63658 16.7129 3.75365 16.7086 3.87117V19.3612C16.7086 19.8812 16.5698 20.0212 16.0443 20.0212H1.50996C0.984503 20.0212 0.845703 19.8812 0.845703 19.3612V0.651168C0.845703 0.181168 1.01425 0.0211679 1.49013 0.0211679H12.8222C12.9405 0.00721284 13.0605 0.0196863 13.1736 0.0577048C13.2867 0.0957232 13.3901 0.158357 13.4765 0.241168Z",
  fill: "white"
});

var SvgIconDocument = function SvgIconDocument(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-document.6c809fd0.svg";
export { SvgIconDocument as ReactComponent };